import React from "react";
import { TransactionQueryInterface } from "../interfaces/TransactionQueryInterface";
import { TransactionDataInterface, defaultTransactionData } from "../interfaces/TransactionDataInterface";
import i18n from "i18next";
import { useAuth } from "./Auth";

const TransactionsContext = React.createContext({
  loading: true,
  fetchTransactions: (transactionQuery) => {},
  transactionsData: [defaultTransactionData],
});

export const TransactionsProvider = (props) => {
  const auth = useAuth();

  const [loading, setLoading] = React.useState(true);
  const [transactionsData, setTransactionsData] = React.useState<TransactionDataInterface[]>([]);

  const fetchTransactions = async (transactionQuery: TransactionQueryInterface) => {
    if (!transactionQuery) {
      setLoading(false);
      return;
    }
    setLoading(true);
    setTransactionsData([]);
    try {
      const body = {
        memberid: transactionQuery.memberId,
        lastname: transactionQuery.lastName
      };

      const requestOptions = {
        method: "POST",
        responseType: "application/json",
        body: JSON.stringify(body),
        headers: {
          "Content-Type": "application/json",
          "Accept": "application/json",
          "Authorization": "Bearer " + auth.currentToken()
        }
      };

      const rawData = await fetch(process.env.REACT_APP_PACTOOL_API_URL + "/transactions",requestOptions)
        .then((response) => response.json())
        .then((response) => {
          return response;
        });

      // 1000 - login sucessful with token
      if (rawData?.code === 1000) {
        setTransactionsData(rawData.data);
        return {
          status: "SUCCESS",
          count: rawData?.data.length
        };
      }

      // for all other error cases
      if (rawData?.code) {
        if (rawData?.code === 1013) {
          return {
            status: "FAIL",
            code: rawData?.code,
            error: rawData?.msg,
            message: "transactions.block-form.error.validation.failed"
          };
        }
        if (rawData?.code === 1005) {
          return {
            status: "FAIL",
            code: rawData?.code,
            error: rawData?.msg,
            message: "all.block-form.error.1005"
          };
        }

        if (i18n.exists("transactions.block-form.error." + rawData?.code)){
          return {
            status: "FAIL",
            code: rawData?.code,
            error: rawData?.msg,
            message: "transactions.block-form.error." + rawData?.code
          };
        }
        return {
          status: "FAIL",
          code: "1010",
          error: "System Error",
          message:   "all.block-form.error.1010"
        };

      }
      
    } catch (error: any) {
      setLoading(false);
      console.debug("ERROR: unexpected error occured ", error);
      return {
        status: "FAIL",
        code: "0000",
        error: "API down",
        message: "all.block-form.error.0000"
      };
    } finally {
      setLoading(false);
    }
  };

  return (
    <TransactionsContext.Provider
      value={{
        loading,
        fetchTransactions,
        transactionsData
      }}
    >
      {props.children}
    </TransactionsContext.Provider>
  );
};

export const useTransactions = () => {
  const context = React.useContext(TransactionsContext);
  return context;
};
